import Icon from 'veui/components/Icon'

Icon.register({
  'flower-filled': {
    paths: [
      {
        d: 'M459.07 500.81l-.23.07-.37.11-1.55.46A254.28 254.28 0 01416 510v194a32 32 0 11-64 0V510a254.28 254.28 0 01-40.92-8.56l-1.55-.46-.37-.11-.23-.07a258.1 258.1 0 01-129.74-91.2 256.12 256.12 0 01-12.65-288.74 32 32 0 0136.53-13.68 255.28 255.28 0 0177.5 39.23A256.51 256.51 0 01365.69 45.9a32 32 0 0136.62 0 256.51 256.51 0 0185.12 100.52 255.28 255.28 0 0177.5-39.23 32 32 0 0136.53 13.68 256.09 256.09 0 01-12.66 288.74 258 258 0 01-129.73 91.2zM704 512c-98 0-177.61 74.12-219.41 143.48a32 32 0 0054.82 33c18.73-31.09 44.13-59.15 71.52-79C641.16 587.59 673.34 576 704 576a32 32 0 100-64zm-640 0a32 32 0 100 64c30.66 0 62.84 11.59 93.07 33.51 27.39 19.86 52.79 47.92 71.52 79a32 32 0 1054.82-33C241.61 586.12 162 512 64 512z'
      }
    ],
    width: '768',
    height: '768'
  }
})
